import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Alert as ChakraAlert } from '@chakra-ui/react';
export const Alert = React.forwardRef(function Alert(props, ref) {
    const { title, children, icon, startElement, endElement, hideIndicator, ...rest } = props;
    return (_jsxs(ChakraAlert.Root, { ref: ref, ...rest, children: [!hideIndicator &&
                (startElement || (icon && _jsx(ChakraAlert.Indicator, { children: icon }))), children ? (_jsxs(ChakraAlert.Content, { children: [_jsx(ChakraAlert.Title, { children: title }), _jsx(ChakraAlert.Description, { children: children })] })) : (_jsx(ChakraAlert.Title, { flex: "1", children: title })), endElement] }));
});
